import { useTranslation } from "react-i18next";
import {
  getFormativeAssessment,
  useCreateFormativeAssessment,
  useGetFormativeAssessment,
} from "@packages/api/madlenAPI";
import {
  FormativeAssessmentCreateRequestDtoCourseName,
  FormativeAssessmentResponseDto,
} from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import FormativeAssessmentCard from "../../../components/formative-assessment/FormativeAssessmentCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateFormativeAssessmentView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("formativeAssessment.result.loading.title")}
      backPath="/content/formative-assessment"
      themeColor="yellow"
      loadingTitle={t("formativeAssessment.result.loading.title")}
      errorTitle={t("formativeAssessment.result.error.title")}
      errorDescription={t("formativeAssessment.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    onCreateAgain,
  }: {
    toolData: FormativeAssessmentResponseDto;
    onCreateAgain: () => void;
  }) => (
    <FormativeAssessmentCard
      assessment={toolData}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="formativeAssessment"
      useCreateTool={useCreateFormativeAssessment}
      useGetTool={useGetFormativeAssessment}
      getTool={getFormativeAssessment}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: FormativeAssessmentResponseDto) =>
        data?.assessmentMethodology && data.assessmentMethodology.length > 0
      }
    />
  );
};

export default CreateFormativeAssessmentView;
